<div class="dashboard-container">
  <app-header></app-header>
  <div class="dashboard-divider">
    <mat-divider></mat-divider>
  </div>
  <div class="dashboard-cards-wrapper" *ngIf="showCards">
    <div class="card" *ngFor="let card of cards">
      <!-- <h2>{{ card.header }}</h2> -->
      <p class="card-description">{{ card.description }}</p>
      <button mat-flat-button color="primary" class="card-button" (click)="navigateTo(card.route)">
        {{ card.header }}
      </button>
    </div>
  </div>
  <div class="dash-assistants" *ngIf="showAssistants" @fade>
    <!-- <span class="title">Assistants</span> -->
    <app-assistants *ngIf="showAssistants"></app-assistants>
  </div>
</div>
